module.exports = __webpack_public_path__ + "img/ultra_1_feature_02.2984e427.jpg";